// Indian Rupee + Indian numbering system formatter
export const formatINR = (value, withSymbol = true) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return withSymbol ? "₹0" : "0";
  }
  const n = Math.round(Number(value));
  const formatted = new Intl.NumberFormat("en-IN").format(n);
  return withSymbol ? `₹${formatted}` : formatted;
};

export const formatShortINR = (value) => {
  const n = Math.round(Number(value || 0));
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(1)}K`;
  return `₹${n}`;
};

export const percent = (v) => `${Math.round(Number(v || 0))}%`;

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
  } catch {
    return "—";
  }
};
